// tslint:disable
export enum CallCenterStandardDaylightObserved {
    /**
     * @description Observe Standard and Daylight Savings
     */
    StandardDaylight = 1,
    /**
     * @description Observe Standard Time Only
     */
    StandOnly = 2,
    /**
     * @description Observe Daylight Savings Time Only
     */
    DaylightOnly = 3,
}
(CallCenterStandardDaylightObserved as any)['STANDARDDAYLIGHT'] = 1;
(CallCenterStandardDaylightObserved as any)['STANDONLY'] = 2;
(CallCenterStandardDaylightObserved as any)['DAYLIGHTONLY'] = 3;
